module.exports = __webpack_public_path__ + "static/img/graph_image_type1.b36f0f45.png";